exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{padding:0;margin:0}html{height:100%}#root,body,html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1}body{margin:0;padding:0;font-family:Oswald,sans-serif;font-size:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./src/index.scss
 ** module id = 328
 ** module chunks = 0
 **/